var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showingFolders)?_c('FolderList',{attrs:{"type":_vm.type}}):_c('ImageList',{attrs:{"images":_vm.images,"showSeverityFilters":_vm.showSeverityFilters},on:{"goBack":_vm.folderList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }